import cn from 'classnames';
import * as React from 'react';

import { ComboboxItem } from './style';

export const SlashComboboxItem = ({
  item,
  highlighted,
}: {
  item: { name: string; icon: (props: any) => JSX.Element; subText: string };
  highlighted: boolean;
}) => {
  return (
    <ComboboxItem
      highlighted={highlighted}
      className={cn('text-gray-600', { 'bg-gray-100': highlighted })}
    >
      <div className="flex items-center">
        <span className="mr-8 text-5xl flex">
          <item.icon />
        </span>
        <div className="text-xs flex flex-col">
          <span className={cn('text-black', { 'text-primary-500': highlighted })}>{item.name}</span>
          <span className="text-gray-500">{item.subText}</span>
        </div>
      </div>
    </ComboboxItem>
  );
};
